import { render, staticRenderFns } from "./LabeledDonutChart.vue?vue&type=template&id=2447d614&"
import script from "./LabeledDonutChart.vue?vue&type=script&lang=ts&"
export * from "./LabeledDonutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports